export const getResignationSource = ({verifiedSMS, verifiedEmail}: {verifiedSMS: string | null; verifiedEmail: string | null}) => {
    if (verifiedSMS === "true") {
        return "sms";
    }
    if (verifiedEmail === "true") {
        return "email";
    }
    return null;
};
export const getResignationSource = ({verifiedSMS, verifiedEmail}: {verifiedSMS: string | null; verifiedEmail: string | null}) => {
    if (verifiedSMS === "true") {
        return "sms";
    }
    if (verifiedEmail === "true") {
        return "email";
    }
    return null;
};
